var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2468 13.8796H20.2361C20.441 14.4408 20.553 15.0463 20.553 15.6775V23.2769C20.553 23.5401 20.5072 23.7927 20.4238 24.0276H23.748C24.9898 24.0276 26 23.0173 26 21.7756V17.6328C26 15.5633 24.3163 13.8796 22.2468 13.8796Z",
    fill: "#545565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44706 15.6775C5.44706 15.0463 5.55903 14.4408 5.76399 13.8796H3.75325C1.68371 13.8796 0 15.5633 0 17.6329V21.7757C0 23.0174 1.01019 24.0276 2.25195 24.0276H5.5762C5.49287 23.7926 5.44706 23.5401 5.44706 23.2769V15.6775Z",
    fill: "#545565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2984 11.9243H10.7016C8.63207 11.9243 6.94836 13.608 6.94836 15.6776V23.277C6.94836 23.6915 7.28444 24.0276 7.69901 24.0276H18.301C18.7156 24.0276 19.0517 23.6916 19.0517 23.277V15.6776C19.0517 13.608 17.368 11.9243 15.2984 11.9243Z",
    fill: "#545565"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.97241C10.5111 1.97241 8.48627 3.99727 8.48627 6.48621C8.48627 8.17444 9.41805 9.64888 10.7941 10.423C11.4468 10.7901 12.1993 11 13 11C13.8007 11 14.5532 10.7901 15.2059 10.423C16.582 9.64888 17.5138 8.17439 17.5138 6.48621C17.5138 3.99732 15.4889 1.97241 13 1.97241Z",
    fill: "#545565"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07396 6.17944C3.21257 6.17944 1.69827 7.69374 1.69827 9.55513C1.69827 11.4165 3.21257 12.9308 5.07396 12.9308C5.54613 12.9308 5.99574 12.833 6.40418 12.6572C7.11034 12.3532 7.6926 11.815 8.05289 11.1409C8.30578 10.6678 8.44965 10.128 8.44965 9.55513C8.44965 7.69379 6.93535 6.17944 5.07396 6.17944Z",
    fill: "#545565"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9261 6.17944C19.0647 6.17944 17.5504 7.69374 17.5504 9.55513C17.5504 10.128 17.6942 10.6678 17.9471 11.1409C18.3074 11.8151 18.8897 12.3532 19.5959 12.6572C20.0043 12.833 20.4539 12.9308 20.9261 12.9308C22.7875 12.9308 24.3018 11.4165 24.3018 9.55513C24.3018 7.69374 22.7875 6.17944 20.9261 6.17944Z",
    fill: "#545565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.c15dc9f57ff1e350499842f667e01b38.svg";
export { ForwardRef as ReactComponent };